module.exports = __webpack_public_path__ + "img/href.518f8678.jpg";